// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.desc-box[data-v-566475ac] {\n  margin-top: 20px;\n}\n.title[data-v-566475ac] {\n  color: #333333;\n  font-weight: 700;\n  margin-bottom: 15px;\n}\n.text[data-v-566475ac] {\n  color: #666666;\n  font-size: 13px;\n  line-height: 25px;\n}\n", ""]);
// Exports
module.exports = exports;
